export const USER_DEFAULT_KEY = "ET_Launchpad_Main_UserID_Default";
export const TEAM_TAB_KEY = "ET_Launchpad_Team_ID";
export const TEAM_PERSONAS = ["Gift Officer (and support staff)", "Donor Experience Officer"];
export const ALL_ACTIVITY = { value: "All", label: "Everything" };
export const PORTFOLIO_ACTIVITY = { value: "Portfolio", label: "Any Team" };
